// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3Dtph","header":"PatientBlock_header__IYaLM","label":"PatientBlock_label__1OnBm","option":"PatientBlock_option__3FgzY"};